/**
 * Anonymize OES names in report data.
 * Replaces all oes_name values with sequential codes (OES-001, OES-002, etc.)
 * Mapping is deterministic: sorted by oes_id so the same OES always gets the same code.
 *
 * Does NOT anonymize: organization, sectors, assessment name, threats, vulnerabilities.
 *
 * @param {Object} data - Raw report summary data from /admin/reports/summary
 * @returns {Object} Deep-cloned data with anonymized OES names
 */
export default function anonymizeReport(data) {
  if (!data) return data;

  // Build stable oes_id -> code mapping from criticality rows (authoritative OES list)
  const allOes = [...(data.oes_criticality_rows || [])];
  allOes.sort((a, b) => (a.oes_id || 0) - (b.oes_id || 0));
  const codeMap = {};
  allOes.forEach((row, i) => {
    codeMap[row.oes_id] = `OES-${String(i + 1).padStart(3, '0')}`;
  });

  // Also map by name for arrays that don't have oes_id
  const nameMap = {};
  allOes.forEach((row) => {
    if (row.oes_name && codeMap[row.oes_id]) {
      nameMap[row.oes_name] = codeMap[row.oes_id];
    }
  });

  // Deep clone
  const out = JSON.parse(JSON.stringify(data));

  // Anonymize oes_criticality_rows
  (out.oes_criticality_rows || []).forEach((row) => {
    if (codeMap[row.oes_id]) row.oes_name = codeMap[row.oes_id];
    row.logo = null;
  });

  // Anonymize oes_posture_data
  (out.oes_posture_data || []).forEach((row) => {
    if (codeMap[row.oes_id]) row.oes_name = codeMap[row.oes_id];
  });

  return out;
}
